import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { money } from "utils/helpers";
import { RentalStockStatusOptions } from "utils/Constant";

/**
 * Exports the Rental Stock list to a PDF file.
 * @param {Array} listData - array of rental stock rows (same shape as rentalStockList?.data?.listData)
 */
export function exportRentalStockToPdf(listData = []) {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    doc.setFontSize(14);
    doc.text("Laporan Stock Rental", 40, 40);

    const columns = [
        { header: "No", dataKey: "rowNumber" },
        { header: "Kode Stock", dataKey: "stockCode" },
        { header: "Nama Item", dataKey: "productName" },
        { header: "Harga Rental (Session)", dataKey: "rentalPriceSession" },
        { header: "Harga Rental (Daily)", dataKey: "rentalPriceDay" },
        { header: "Selling Price", dataKey: "sellingPrice" },
        { header: "Stock Status", dataKey: "stockStatus" },
        { header: "Status", dataKey: "status" },
    ];

    const rows = listData.map((row, i) => ({
        rowNumber: i + 1,
        stockCode: row.stockCode,
        productName: row.productName,
        rentalPriceSession: `Rp ${money(row.rentalPriceSession)}`,
        rentalPriceDay: `Rp ${money(row.rentalPriceDay)}`,
        sellingPrice: `Rp ${money(row.sellingPrice)}`,
        stockStatus:
            RentalStockStatusOptions.find((x) => x.value === row.stockStatus)?.label ?? "-",
        status: row.status ? "Active" : "Inactive",
    }));

    autoTable(doc, {
        startY: 58,
        columns,
        body: rows,
        styles: { fontSize: 8, cellPadding: 4 },
        headStyles: { fillColor: [30, 30, 30], textColor: 255 },
    });

    const fileName = `rental-stock-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
}